// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"36b306978ba6333e281d","500":"e63f508ddcecafebca26"}[chunkId] + ".css";
};